import { render, staticRenderFns } from "./UserStatisticCard.vue?vue&type=template&id=16cb5cf2&scoped=true"
import script from "./UserStatisticCard.vue?vue&type=script&lang=js"
export * from "./UserStatisticCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cb5cf2",
  null
  
)

export default component.exports